import React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * Item de navigation dans la sidebar
 * Utilise NavLink pour la gestion automatique de l'état actif
 * Supporte un badge optionnel (ex: notifications)
 */
const SidebarItem = ({ item, isCollapsed, onClick, badge }) => {
  const { id, name, icon, path } = item;

  return (
    <NavLink
      to={path}
      className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
      onClick={onClick}
      aria-label={name}
    >
      <span className="sidebar-item-icon" aria-hidden="true">
        {icon}
        {badge > 0 && (
          <span className="sidebar-item-badge" title={`${badge} en attente`}>
            {badge > 99 ? '99+' : badge}
          </span>
        )}
      </span>
      <span className="sidebar-item-text">
        {name}
        {badge > 0 && !isCollapsed && (
          <span className="sidebar-item-badge-inline">{badge}</span>
        )}
      </span>
      {isCollapsed && (
        <span className="sidebar-item-tooltip" role="tooltip">
          {name}
          {badge > 0 && ` (${badge})`}
        </span>
      )}
    </NavLink>
  );
};

export default React.memo(SidebarItem);
